import React from 'react';
import { startsWith } from 'lodash';

export const DownloadLink = (props) => {
  const { uri, children } = props;

  if(!uri) return null;

  let downloadUrl = `/api/download/?uri=${uri}`;
  if(startsWith(uri, '/temp/')) {
    downloadUrl = uri;
  }

  return (
    <a href={downloadUrl} target={"_blank"}>
      {children}
    </a>
  );
};